import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-3 flex justify-between rounded-md bg-white border-2 border-gray-200" }
const _hoisted_2 = { class: "w-8/12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { class: "mt-4 mb-1 flex-1 flex justify-between items-center" }
const _hoisted_10 = { class: "text-xs text-gray-500 grid grid-cols-3 gap-2 content-start" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 締切時刻")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 表示期間")
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = { class: "font-bold break-words" }
const _hoisted_20 = { class: "w-4/12" }
const _hoisted_21 = { class: "flex justify-end mb-2" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 確認済にする ")
const _hoisted_23 = { class: "flex justify-end mb-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "mr-2" }, "提出物を確認する", -1)
const _hoisted_25 = { class: "flex justify-end" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "mr-2" }, "全生徒の提出状況", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (
          _ctx.status === 'rejected_unsubmitted' || _ctx.status === 'rejected_submitted'
        )
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["mx-1 text-xs px-2 py-1 border rounded inline-block", {
          'border-gray-400': _ctx.status === 'rejected_unsubmitted',
          'text-gray-400': _ctx.status === 'rejected_unsubmitted',
          'border-red-400': _ctx.status === 'rejected_submitted',
          'text-red-400': _ctx.status === 'rejected_submitted'
        }]
          }, [
            (
            _ctx.status === 'rejected_unsubmitted' || _ctx.status === 'rejected_submitted'
          )
              ? (_openBlock(), _createBlock("span", _hoisted_3, "再提出"))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: ["text-xs px-2 py-1 border rounded inline-block", {
          'border-gray-400':
            _ctx.status === 'unsubmitted' || _ctx.status === 'rejected_unsubmitted',
          'text-gray-400':
            _ctx.status === 'unsubmitted' || _ctx.status === 'rejected_unsubmitted',
          'border-red-400':
            _ctx.status === 'submitted' || _ctx.status === 'rejected_submitted',
          'text-red-400':
            _ctx.status === 'submitted' || _ctx.status === 'rejected_submitted',
          'border-green-500': _ctx.status === 'fulfilled',
          'text-green-500': _ctx.status === 'fulfilled'
        }]
      }, [
        (_ctx.status === 'unsubmitted')
          ? (_openBlock(), _createBlock("span", _hoisted_4, "実施中"))
          : _createCommentVNode("", true),
        (_ctx.status === 'submitted')
          ? (_openBlock(), _createBlock("span", _hoisted_5, "確認待ち"))
          : _createCommentVNode("", true),
        (_ctx.status === 'rejected_unsubmitted')
          ? (_openBlock(), _createBlock("span", _hoisted_6, "実施中"))
          : _createCommentVNode("", true),
        (_ctx.status === 'rejected_submitted')
          ? (_openBlock(), _createBlock("span", _hoisted_7, "確認待ち"))
          : _createCommentVNode("", true),
        (_ctx.status === 'fulfilled')
          ? (_openBlock(), _createBlock("span", _hoisted_8, "確認済"))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode("p", null, _toDisplayString(_ctx.title) + "_" + _toDisplayString(_ctx.label), 1),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", null, [
            _hoisted_11,
            _hoisted_12,
            _createVNode("span", _hoisted_13, _toDisplayString(_ctx.toTimeString(_ctx.closedAt)), 1)
          ]),
          (_ctx.checkedAt)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.status === "rejected_unsubmitted" ||
              _ctx.status === "rejected_submitted"
                ? "確認時刻(再提出依頼前)"
                : "確認時刻"), 1),
                _hoisted_15,
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.toTimeString(_ctx.checkedAt)), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", null, [
            _hoisted_17,
            _hoisted_18,
            _createVNode("span", _hoisted_19, _toDisplayString(_ctx.toDateString(_ctx.submittableFrom)) + "~" + _toDisplayString(_ctx.toDateString(_ctx.displayEndAt)), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: 
            _ctx.status === 'unsubmitted' ||
            _ctx.status === 'rejected_unsubmitted' ||
            _ctx.status === 'fulfilled'
          ,
          onClick: _ctx.confirm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_m_icon, {
              type: "check",
              width: "4",
              class: "mr-2"
            }),
            _hoisted_22
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_m_button, {
          color: "gray-500",
          size: "sm",
          "font-weight": "normal",
          text: "",
          onClick: _ctx.click,
          isDiv: true
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            _createVNode(_component_m_icon, { type: "external" })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode("div", _hoisted_25, [
        _createVNode(_component_m_button, {
          color: "gray-500",
          size: "sm",
          "font-weight": "normal",
          text: "",
          link: `/submission_master/${_ctx.submissionMasterId}`
        }, {
          default: _withCtx(() => [
            _hoisted_26,
            _createVNode(_component_m_icon, { type: "people" })
          ]),
          _: 1
        }, 8, ["link"])
      ])
    ])
  ]))
}